import type { ComponentInfo } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const trustPilotMicroReviewCountInputs = [
  {
    name: "styleHeight",
    friendlyName: "Widget Height",
    type: "string",
    defaultValue: "24px",
  },
  {
    name: "styleWidth",
    friendlyName: "Widget Width",
    type: "string",
    defaultValue: "100%",
  },
  {
    name: "theme",
    friendlyName: "Theme",
    type: "string",
    enum: ["light", "dark"],
    defaultValue: "light",
  },
  {
    name: "minReviewCount",
    friendlyName: "Minimum Review Count",
    type: "string",
    defaultValue: "0",
  },
  {
    name: "styleAlignment",
    friendlyName: "Alignment",
    type: "string",
    enum: ["left", "center", "right"],
    defaultValue: "center",
  },
] as const satisfies ComponentInfo["inputs"];

export type TrustPilotMicroReviewCountProps = BuilderComponentProps<typeof trustPilotMicroReviewCountInputs>;

export const TrustPilotMicroReviewCountComponent: RegisteredComponent = {
  name: "TrustPilotMicroReviewCount",
  friendlyName: "Trust Pilot Micro Review Count",
  component: dynamic(async () =>
    withValidation(
      trustPilotMicroReviewCountInputs,
      (await import("./TrustPilotMicroReviewCount")).TrustPilotMicroReviewCount,
      "TrustPilotMicroReviewCount"
    )
  ),
  inputs: trustPilotMicroReviewCountInputs,
};
